import 'core-js/stable';
import 'regenerator-runtime/runtime';

import T from 'i18n-react';

import '@fontsource/roboto';

import '../scss/front.scss';
import '../scss/features.scss';

require('../src/react_ujs_wrapper')(
  require.context('components/feature', true),
  require('../src/front/ThemeProvider/withFrontTheme').default,
);
require('@rails/ujs').start();

function importAll(r) {
  r.keys().forEach(r);
}
const merge = require('lodash/merge');
T.setTexts(
  merge(
    {},
    require('../src/core/locales/ja.json'),
    require('../src/front/locales/ja.json'),
  ),
);

importAll(require.context('../src/feature/', true, /\.jsx?$/));

importAll(require.context('../images', true));
